import React, { Component } from 'react';
import { InView } from 'react-intersection-observer';

import { addClass, removeClass } from '../../utils/dom.js'

class Blackout extends Component {


    constructor(props) {
       
        super(props)

        this.state = {
            isVisible: false,
            isActive: false
        }

        this.onChange = this.onChange.bind(this)

    }

    componentDidMount() {

        setTimeout(() => {

            this.setState({
                isActive: true
            })

        }, 2000)

    }

    componentWillUnmount() {
        const className = 'blackout'
        removeClass(document.body, className)
    }

    onChange(inView) {

        const body = document.body
        const className = 'blackout'

        if (inView) {
            addClass(body, className)
        }
        else {
            removeClass(body, className)

        }

    }


    render() {

        const { isActive } = this.state

        return (

            <InView onChange={this.onChange} skip={!isActive} threshold={1}>
                {({ ref }) => (
                    <section ref={ref}>

                        {this.props.children}

                    </section>
                )}
            </InView>

        );
    }
}

export default Blackout;
